import { CellContext, ColumnDef } from '@tanstack/react-table';
import { IUseFormStructureItem, NumberUtils } from 'modules';
import type { AgencyEntity, TransactionOrder } from 'services/openapi';
import * as Yup from 'yup';

export type FilterType = {
  agencyCode?: string;
  customerCodes: string[];
  refreshData: number;
};

export const initFilterValues: FilterType = {
  agencyCode: '',
  customerCodes: [],
  refreshData: 0,
};

export const filterOptions: IUseFormStructureItem[] = [
  {
    name: 'agencyCode',
  },
  {
    name: 'customerCodes',
    validate: Yup.string().required('Vui lòng nhập mã khách hàng'),
  },
];

export const columnsDefined: ColumnDef<TransactionOrder>[] = [
  {
    accessorKey: 'type',
    header: 'Loại dịch vụ',
    size: 60,
  },
  {
    accessorKey: 'customerCode',
    header: 'Mã khách hàng',
  },
  {
    accessorKey: 'customerFullName',
    header: 'Tên khách hàng',
    size: 300,
  },
  {
    accessorKey: 'customerAddress',
    header: 'Địa chỉ',
    size: 400,
  },
  {
    accessorKey: 'period',
    header: 'Kỳ tháng',
    // cell: (info: CellContext<TransactionOrder, unknown>) => info.getValue(),
    cell: (info) => {
      const period = info.row.original.period;
      const month = String(period)?.slice?.(4, 6) || '';
      const year = String(period)?.slice?.(0, 4) || '';
      return `${month}/${year}`;
    },
    size: 100,
  },
  {
    accessorKey: 'amount',
    header: 'Số tiền',
    cell: (info: CellContext<TransactionOrder, unknown>) =>
      NumberUtils.toFormatNumber((info.getValue() as number) || 0),
    size: 100,
  },
];

export const convertSelectOptions = (data: AgencyEntity[]) => {
  if (!data || !data.length) return [];

  return data?.map((item) => {
    return {
      label: `${item?.agencyName} - ${item?.agencyId}`,
      value: item?.agencyId,
    };
  });
};

export const convertVariables = (variables: FilterType) => {
  const { customerCodes, ...rest } = variables;

  const formatCustomerCodes = () => {
    if (!customerCodes) return [];

    if (Array.isArray(customerCodes) && customerCodes.length) {
      return customerCodes?.map((item) =>
        rest?.agencyCode ? (rest?.agencyCode + item).replace(/\s+/g, '') : item,
      );
    }

    return customerCodes;
  };

  return {
    customerCodes: formatCustomerCodes().toString(),
  };
};
